import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Input } from '../ui/input';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const OTHER = '__other__';
let cache = null;

/** Loads the admin-maintained standard override reasons once per page. */
export function useOverrideReasons() {
  const [reasons, setReasons] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    axios.get(`${API_URL}/api/product-pricing/override-reasons`, { withCredentials: true }).then((r) => { cache = r.data.reasons || []; setReasons(cache); }).catch(() => {});
  }, []);
  return reasons;
}

/** Standard reason select + "Other…" free text. `value` is the stored reason string. */
export function ReasonPicker({ value, onChange, reasons, disabled, placeholder = 'Reason (required)', invalid, testId }) {
  const isStandard = !!value && reasons.includes(value);
  const [other, setOther] = useState(!!value && !isStandard);
  const showOther = other || (!!value && !isStandard);
  return (
    <div className="flex flex-col gap-1 w-full" data-testid={testId}>
      <select className={`h-7 text-xs w-full rounded-md border bg-white px-1.5 ${invalid && !value ? 'border-rose-300' : 'border-slate-200'}`} disabled={disabled}
        value={showOther ? OTHER : (value || '')} data-testid={`${testId}-select`}
        onChange={(e) => { if (e.target.value === OTHER) { setOther(true); if (isStandard) onChange(''); } else { setOther(false); onChange(e.target.value); } }}>
        <option value="">{placeholder}</option>
        {reasons.map((r) => <option key={r} value={r}>{r}</option>)}
        <option value={OTHER}>Other… (type a reason)</option>
      </select>
      {showOther && <Input className={`h-7 text-xs w-full ${invalid && !(value || '').trim() ? 'border-rose-300' : ''}`} placeholder="Type the reason" value={value || ''} onChange={(e) => onChange(e.target.value)} disabled={disabled} data-testid={`${testId}-other`} />}
    </div>
  );
}
